(function () {
    if (document.querySelector("body#attractions") !== null) {
        // SETTINGS 
        let categoriesData = [];

        const CATEGORY_SELECTOR = document.querySelector("select#attraction-category"),
            DISTANCE_SELECTOR = document.querySelector("select#attraction-distance"),
            ATTRACTIONS_WRAPPER = document.querySelector("#attractions--wrapper"),
            LIGHTBOX__FULL_WRAPPER = document.querySelector("#attraction--ligthbox-wrapper"),
            LIGHTBOX__CLOSE_BUTTON = "close--lightbox",
            $LIGHTBOX__CLOSE_BUTTON = document.querySelector(`#${LIGHTBOX__CLOSE_BUTTON}`),
            LIGHTBOX_WRAPPER = document.querySelector("#attraction--ligthbox");

        /*
         * HELPERS
         ********************************************************************************/
        function PopulateSelectors(el, data, key, selector = "Select an Option") {
            let allKeys = Object.values(data).map(value => value[key]);
            let keys = allKeys.filter((item, index) => allKeys.indexOf(item) >= index);
            keys.sort((a, b) => a.localeCompare(b));
            let markup = `<option value=''>${selector}</option>`;
            keys.forEach(val => {
                if (val !== "") markup += `<option value='${val}'>${val}</option>`;
            });
            el.innerHTML = markup;
        }

        function GetAttractionsMarkup(attractions) {
            let markup = attractions.map(getAttractionMarkUp).join("");
            ATTRACTIONS_WRAPPER.innerHTML = markup;
            document.querySelectorAll("article[data-attraction]").forEach(element => {
                element.addEventListener("click", () => OpenLightbox(element), false);
            });
        }

        function getAttractionMarkUp(attraction) {
            const { id, name, thumb, description, distance, walking, biking, driving } = attraction;

            let imageAttraction = (thumb[0].thumbnail && thumb[0].thumbnail.split('/').pop().length > 11)
                ? thumb[0].thumbnail
                : 'https://via.placeholder.com/480x300';

            let iconMiles = '<svg xmlns="http://www.w3.org/2000/svg" width="12" height="19.04" viewBox="0 0 12 19.04"><path style="transform:translateX(1px)" d="m6,0C2.68,0,0,2.98,0,6.66c0,5,6,12.37,6,12.37,0,0,6-7.38,6-12.37C12,2.98,9.32,0,6,0Zm0,9.72c-1.68-.02-3.04-1.39-3.03-3.08.01-1.68,1.38-3.04,3.07-3.04,1.68,0,3.05,1.37,3.05,3.06,0,1.7-1.39,3.06-3.09,3.06Z"/></svg>';
            let iconWalking = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M9.797 8.906l-2.813 14.109h2.109l1.828-8.016 2.063 2.016v6h2.016v-7.5l-2.109-2.016 0.609-3c1.313 1.5 3.281 2.484 5.484 2.484v-1.969c-1.922 0-3.469-1.031-4.266-2.438l-1.031-1.594c-0.422-0.609-0.984-0.984-1.688-0.984-0.281 0-0.516 0.094-0.797 0.094l-5.203 2.203v4.688h2.016v-3.375l1.781-0.703zM13.5 5.484c-1.078 0-2.016-0.891-2.016-1.969s0.938-2.016 2.016-2.016 2.016 0.938 2.016 2.016-0.938 1.969-2.016 1.969z"/></svg>';
            let iconBiking = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.984 20.484c1.922 0 3.516-1.547 3.516-3.469s-1.594-3.516-3.516-3.516-3.469 1.594-3.469 3.516 1.547 3.469 3.469 3.469zM18.984 12c2.813 0 5.016 2.203 5.016 5.016s-2.203 4.969-5.016 4.969-4.969-2.156-4.969-4.969 2.156-5.016 4.969-5.016zM10.781 10.5l2.203 2.297v6.188h-1.969v-4.969l-3.234-2.813c-0.422-0.281-0.563-0.797-0.563-1.406 0-0.516 0.141-0.984 0.563-1.406l2.813-2.813c0.281-0.422 0.797-0.563 1.406-0.563s1.078 0.141 1.594 0.563l1.922 1.922c0.891 0.891 2.063 1.5 3.563 1.5v2.016c-2.109 0-3.75-0.797-5.063-2.109l-0.797-0.797zM5.016 20.484c1.922 0 3.469-1.547 3.469-3.469s-1.547-3.516-3.469-3.516-3.516 1.594-3.516 3.516 1.594 3.469 3.516 3.469zM5.016 12c2.813 0 4.969 2.203 4.969 5.016s-2.156 4.969-4.969 4.969-5.016-2.156-5.016-4.969 2.203-5.016 5.016-5.016zM15.516 5.484c-1.078 0-2.016-0.891-2.016-1.969s0.938-2.016 2.016-2.016 1.969 0.938 1.969 2.016-0.891 1.969-1.969 1.969z"/></svg>';
            let iconDriving = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5.016 11.016h13.969l-1.5-4.5h-10.969zM17.484 15.984c0.844 0 1.5-0.656 1.5-1.5s-0.656-1.5-1.5-1.5-1.5 0.656-1.5 1.5 0.656 1.5 1.5 1.5zM6.516 15.984c0.844 0 1.5-0.656 1.5-1.5s-0.656-1.5-1.5-1.5-1.5 0.656-1.5 1.5 0.656 1.5 1.5 1.5zM18.938 6l2.063 6v8.016c0 0.563-0.422 0.984-0.984 0.984h-1.031c-0.563 0-0.984-0.422-0.984-0.984v-1.031h-12v1.031c0 0.563-0.422 0.984-0.984 0.984h-1.031c-0.563 0-0.984-0.422-0.984-0.984v-8.016l2.063-6c0.188-0.609 0.797-0.984 1.453-0.984h10.969c0.656 0 1.266 0.375 1.453 0.984z"/></svg>';

            let milesInfo = distance ? `<li>${iconMiles} <span>${distance} Miles from Chico Hot Springs Resort</span></li>` : "";
            let walkingInfo = walking ? `<li>${iconWalking} <span>${walking} Minutes Walking</span></li>` : "";
            let bikingInfo = biking ? `<li>${iconBiking} <span>${biking} Minutes Biking</span></li>` : "";
            let drivingInfo = driving ? `<li>${iconDriving} <span>${driving} Minutes Driving</span></li>` : "";

            let additionalInfo = (milesInfo || walkingInfo || bikingInfo || drivingInfo)
                ? `<ul class="additional-info">${milesInfo}${walkingInfo}${bikingInfo}${drivingInfo}</ul>` : "";

            return `<article data-attraction="${id}" class="attraction" data-name="${name}">
                        <div class="attraction--wrapper">
                            <figure class="attraction-image">
                                <img src="${imageAttraction}" alt="${thumb[0].alt !== 'null' ? thumb[0].alt : 'placeholder image'}">
                            </figure>
                            <div class="info-wrapper">
                                <h2>${name}</h2>
                                <p class="description">${description}</p>
                                ${additionalInfo}
                                <a class="learn-more-btn btn"><span>learn more</span></a>
                            </div>
                        </div>
                    </article>`;
        }


        const noContentfilter = `<div class='no-filter-content'>
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                                        <path d="M16 0v0c8.837 0 16 7.163 16 16s-7.163 16-16 16c-8.837 0-16-7.163-16-16s7.163-16 16-16zM14 22h4v4h-4zM14 6h4v12h-4z"/>
                                    </svg>
                                    There isn't any content with this filter
                                </div>`;

        /*
         * GET ATTRACTIONS
         ********************************************************************************/
        function GetAttractions() {
            fetch(`${site_url}ajax/functions.php?operation=Frontend__GetAttractions`)
                .then(resp => resp.json())
                .then(data => {
                    PopulateSelectors(CATEGORY_SELECTOR, data.pins, "category", 'Select Category');
                    GetAttractionsMarkup(data.pins);
                    categoriesData = data;
                });
        }

        /*
         * FILTER DATA
         ********************************************************************************/
        function GetFilterData() {
            let category = CATEGORY_SELECTOR.value;
            let distance = DISTANCE_SELECTOR.value;

            let result = categoriesData.pins.filter(item => {
                if (category && item.category !== category) return false;
                if (distance) {
                    let [min, max] = distance.split("-").map(Number);
                    let dist = parseFloat(item.distance);
                    if (isNaN(dist) || dist < min || dist > max) return false;
                }
                return true;
            });

            if (result.length) {
                GetAttractionsMarkup(result);
            } else {
                ATTRACTIONS_WRAPPER.innerHTML = noContentfilter;
            }
        }

        /*
         * LIGHTBOX
         ********************************************************************************/
        const LIGHTBOX_OPENED__CLASS = "opened-lightbox";

        function OpenLightbox(element) {
            let pin_id = parseInt(element.getAttribute("data-attraction"));
            let PinInfo = categoriesData.pins.find(p => p.id === pin_id);
            if (!PinInfo) return;
            LIGHTBOX_WRAPPER.innerHTML = getAttractionMarkUp(PinInfo);
            document.body.style.overflowY = 'hidden';
            LIGHTBOX__FULL_WRAPPER.classList.add(LIGHTBOX_OPENED__CLASS);
        }

        function CloseLigthbox(event) {
            if (event.keyCode !== 27 && event.target.id !== LIGHTBOX__CLOSE_BUTTON && !event.target.classList.contains(LIGHTBOX_OPENED__CLASS)) return;
            LIGHTBOX_WRAPPER.innerHTML = "";
            LIGHTBOX__FULL_WRAPPER.classList.remove(LIGHTBOX_OPENED__CLASS);
            document.body.style.overflowY = 'visible';
        }

        /*
         * EVENTS
         ********************************************************************************/
        GetAttractions();

        CATEGORY_SELECTOR.addEventListener("change", GetFilterData);
        DISTANCE_SELECTOR.addEventListener("change", GetFilterData);

        document.querySelector("#attractions-filtering-form").addEventListener("reset", event => {
            setTimeout(GetFilterData, 0);
        });

        document.addEventListener('keydown', event => {
            if (event.keyCode === 27) CloseLigthbox(event);
        });

        LIGHTBOX__FULL_WRAPPER.addEventListener('click', CloseLigthbox);
        $LIGHTBOX__CLOSE_BUTTON.addEventListener('click', CloseLigthbox);

        document.querySelector(".reset-btn").addEventListener("click", function () {
            CATEGORY_SELECTOR.value = "";
            DISTANCE_SELECTOR.value = "";
            GetFilterData();
        });
    }
})();